import React, { createContext, useContext, useState } from 'react';

const ToastContext = createContext({
  toast: () => {},
});

export const Toaster = () => {
  const { toasts } = useToast();
  
  return (
    <div className="fixed top-0 right-0 z-50 p-4 space-y-4 w-full max-w-sm">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`bg-white rounded-lg border shadow-lg p-4 transform transition-all duration-300 ${
            toast.visible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
          }`}
        >
          <div className="flex">
            {toast.variant === 'destructive' && (
              <div className="flex-shrink-0 w-5 h-5 text-red-500 mr-2">⚠️</div>
            )}
            <div>
              {toast.title && <div className="font-medium">{toast.title}</div>}
              {toast.description && <div className="text-sm text-gray-500">{toast.description}</div>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  
  const toast = ({ title, description, variant = 'default' }) => {
    const id = Date.now();
    
    setToasts((prev) => [
      ...prev,
      { id, title, description, variant, visible: false },
    ]);
    
    // Make toast visible after a small delay (for animation)
    setTimeout(() => {
      setToasts((prev) =>
        prev.map((t) => (t.id === id ? { ...t, visible: true } : t))
      );
    }, 50);
    
    // Auto-dismiss after 5 seconds
    setTimeout(() => {
      setToasts((prev) =>
        prev.map((t) => (t.id === id ? { ...t, visible: false } : t))
      );
      
      // Remove from DOM after animation completes
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 300);
    }, 5000);
  };
  
  return (
    <ToastContext.Provider value={{ toast, toasts }}>
      {children}
      <Toaster />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};